import _ from 'lodashParts'

//@formatter:off
const attributeRegexDefinition = '' +
    '(?:' +
        '(?:\\s+[-_A-Za-z0-9]+' +
            '(?:\\s*=\\s*' +
                '(?:' +
                    '(?:"[^"]*")|(?:\'[^\']*\')|[^>\\s]+' +
                ')' +
            ')?' +
        ')*' +
    ')'
//@formatter:on

const linksExtractRegExp = new RegExp('' +
    '<a\\s*' +//is the a tag open
    attributeRegexDefinition +//every possible attribute
    '(href\\s*=\\s*(\'|")(?:(?!\\2).)+\\2)?' +//group 1 is the href containing mailto, group 2 is '|" to allow for negative look behind
    attributeRegexDefinition +//every possible attribute
    '>(.*?)</a>'//g3 is the text that must remain
    , 'gim')

function createDataQueryLink(url, textContent, linksTransformer) {
    const transformedLink = linksTransformer('ExternalLink', url)

    return `<span style="text-decoration:underline"><a dataquery="${encodeDataQuery(transformedLink)}">${textContent}</a></span>`
}

function fixExternalLinks(evt, linksTransformer) {
    let str = evt.data.pasteString

    str = str.replace(linksExtractRegExp, function (match, g1, g2, g3) {
        if (!g1) {
            return g3
        }

        var href = g1.replace(/href\s*=\s*/, '')
        href = href.substring(1, href.length - 1)

        var linkResult = createDataQueryLink(href, g3, linksTransformer)

        return linkResult || g3
    })

    evt.data.pasteString = str
}

function replaceLinkId(pasteString, oldLinkId, newLinkId) {
    var dataQueryRegExp = new RegExp('dataquery\s*=["|\']' + oldLinkId + '["|\']', 'g')

    return pasteString.replace(dataQueryRegExp, `dataquery="${newLinkId}"`)
}

function removeLinkWithDataQuery(pasteStr, dataQuery) {
    var replaceRegex = new RegExp('' +
        '(<span .*?text-decoration.*?>)?' +//group 1 is opening textDecoration
        '<a dataquery=[\'"]' + dataQuery + '[^>]*>' +
        '(<span .*?text-decoration.*?>)?' + // group 2 is opening textDecoration inside <a>
        '(.*?)' +// group 3 is text to remain
        '(</span>)?' + //group 4 is closing tag of group 2
        '<\/a>' +
        '(</span>)?' //group 5 is closing of group 1
        , 'm')

    return pasteStr.replace(replaceRegex, function (match, g1, g2, g3, g4, g5) {
        var result = g3 || ''
        const wrapIfNeeded = (wrapLeft, str, wrapRight) => {
            if (wrapLeft && wrapRight) {
                wrapLeft = wrapLeft.replace(/text-decoration:underline;?/, '')
                    .replace(/style=['"]\s*['"]/, '')
                    .replace(/<span\s*>/, '')
                return wrapLeft ? wrapLeft + str + wrapRight : str
            }
            return (wrapLeft || '') + str + (wrapRight || '')
        }

        result = wrapIfNeeded(g2, result, g4)
        result = wrapIfNeeded(g1, result, g5)

        return result
    })
}

function fixPasteInternalLinks(evt, linksTransformer) {
    var pasteStr = evt.data.pasteString
    const regEx = /dataquery="([^"]+)"/g
    _.forEach(pasteStr.match(regEx), function (val) {
        regEx.lastIndex = 0
        var dataQuery = regEx.exec(val)[1]

        const transformedLink = linksTransformer('InternalLink', decodeDataQuery(dataQuery))

        if (transformedLink) {
            pasteStr = replaceLinkId(pasteStr, dataQuery, encodeDataQuery(transformedLink))
        } else {
            //remove this link since the dataquery could not be resolved from current or copied data
            pasteStr = removeLinkWithDataQuery(pasteStr, dataQuery)
        }
    })

    evt.data.pasteString = pasteStr
}

function extractLinksRefs(data) {
    const linksSet = new Set()
    const regEx = /dataquery="([^"]+)"/g
    _.forEach(data.match(regEx), function (val) {
        regEx.lastIndex = 0
        const dataQuery = regEx.exec(val)[1]

        linksSet.add(decodeDataQuery(dataQuery))
    })

    const retVal = []
    linksSet.forEach(v => { retVal.push(v) })

    return retVal
}

function fixLinks(evt, linksTransformer) {
    if (evt.data.isExternalSourceData) {
        fixExternalLinks(evt, linksTransformer)
    } else {
        fixPasteInternalLinks(evt, linksTransformer)
    }
}

function getAttributesString(dataObj) {
    let retVal = ''
    _.forOwn(dataObj, (value, key) => {
        retVal += `${key}${value ? '="' + value + '"' : ''} `
    })

    return retVal.trim()
}

function convertAttributesToObj(attributesStr) {
    const retVal = {}
    attributesStr = (attributesStr || '').trim()
    const attrRegex = /(?:(?:\s*([-_A-Za-z0-9]+)(?:\s*(?:=\s*(?:(?:"([^"]*)")|(?:'([^']*)')|([^>\s]+))){0,1})))/gi
    _.forEach(attributesStr.match(attrRegex), attributeSet => {
        attrRegex.lastIndex = 0
        const splitted = attrRegex.exec(attributeSet)

        //1 - attribute name
        //2 - value if double quotes, 3 - value if single quotes, 4 - value if no quotes
        //put null in case it's a stand alone value
        retVal[splitted[1]] = splitted[2] || splitted[3] || splitted[4] || null
    })

    return retVal
}

function transformLinkRefsToAttributes(data, convertLinkRefToAttributes) {
    const dataQueryRegexp = /<a\s+dataquery=(?:(?:"([^"]+)")|(?:'([^']+)'))\s*>/gim
    data = (data || '').trim()

    data = data.replace(dataQueryRegexp, (match, g1, g2) => {
        //G1 - if dataQuery is under double quotes
        //G2 - if dataQuery is under single quote
        var dataQuery = g1 || g2

        dataQuery = decodeDataQuery(dataQuery)

        return `<a ${getAttributesString(convertLinkRefToAttributes(dataQuery))}>`
    })

    return data
}

function transformAttributesToLinkRef(data, convertAttributesToLinkRef) {
    const attributesRegexp = /<a\s+((?:(?:\s*(?:[-_A-Za-z0-9]+)(?:\s*(?:=\s*(?:(?:"(?:[^"]*)")|(?:'(?:[^']*)')|(?:[^>\s]+))){0,1}))\s*)*)>/gim
    data = (data || '').trim()

    data = data.replace(attributesRegexp, (match, g1) => {
        const attributesObj = convertAttributesToObj(g1)

        if (!_.isEmpty(attributesObj)) {
            let dataquery = convertAttributesToLinkRef(attributesObj)

            if (dataquery) {
                dataquery = encodeDataQuery(dataquery)

                return `<a dataquery="${dataquery}">`
            }
        }

        return '<a>'
    })

    return data
}

function encodeDataQuery(dataQuery) {
    return btoa(dataQuery)
}

function decodeDataQuery(encodedDataQuery) {
    try {
        if (!encodedDataQuery || !encodedDataQuery.trim()) {
            return ''
        }

        return atob(encodedDataQuery)
    } catch (e) {
        console.warn('failed to decode: ' + encodedDataQuery)

        return encodedDataQuery
    }
}

module.exports = {
    fixLinks,
    transformLinkRefsToAttributes,
    transformAttributesToLinkRef,
    encodeDataQuery,
    decodeDataQuery,
    extractLinksRefs
}



// WEBPACK FOOTER //
// ./src/utils/linkUtils.js